import { render, staticRenderFns } from "./ValidatorPaginationControls.vue?vue&type=template&id=398f0f27&scoped=true&"
import script from "./ValidatorPaginationControls.vue?vue&type=script&lang=ts&"
export * from "./ValidatorPaginationControls.vue?vue&type=script&lang=ts&"
import style0 from "./ValidatorPaginationControls.vue?vue&type=style&index=0&id=398f0f27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f0f27",
  null
  
)

export default component.exports